import { useQueryState } from 'core/use-cases/utilities';

import { useSettingsSelector } from '../selectors';
import { staticRoutes } from '../slice/static-routes';
import { matchPath, useHistory } from 'react-router-dom';
import { Routes } from 'core/domains/settings';

/**
 * Return pathname of the route main
 *
 */
export function useHomepage() {
  const {
    data: { routes },
  } = useSettings();

  const { path = '/' } = routes.find(({ isHomepage }) => isHomepage) || {};

  return path;
}

/**
 * Return settings content and your async request handling
 *
 */
export function useSettings() {
  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(useSettingsSelector);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}

/**
 * Get feature toggle from settings
 *
 */
export function useFeatureToggle(key: string) {
  const {
    data: { featureToggle },
  } = useSettings();

  return featureToggle[key] || false;
}

export function useSearchPage() {
  const {
    data: { routes },
  } = useQueryState(useSettingsSelector);

  const { path } = routes.find(({ isSearchPage }) => isSearchPage) || {};

  return path;
}

/**
 * It is responsible for checking whether to show or hide the header main on the page.
 *
 */

export const defaultRouteSettings = {
  canBlockedResellerAccess: false,
  component: '',
  documentType: '',
  isHomepage: false,
  isMainHeader: false,
  isPrivate: false,
  isSearchPage: false,
  name: '',
  path: '',
};

export function useRouteSettings(): Routes | null {
  const history = useHistory();
  const routes = [
    ...staticRoutes,
    {
      ...defaultRouteSettings,
      path: '/departamentos',
      canBlockedResellerAccess: true,
      isPrivate: true,
    },
  ];

  return (
    routes.find(({ path }) =>
      matchPath(history.location.pathname, { path, exact: true, strict: true }),
    ) || defaultRouteSettings
  );
}
